//803c60c23ac23fa43f45db473e2bb9e6
//https://api.themoviedb.org/3/movie/550?api_key=803c60c23ac23fa43f45db473e2bb9e6
//https://api.themoviedb.org/3/discover/tv?api_key=803c60c23ac23fa43f45db473e2bb9e6&with_networks=213
var API_KEY = "803c60c23ac23fa43f45db473e2bb9e6";
var requests = {
  fetchNetflixOriginals: `/discover/tv?api_key=${API_KEY}&with_networks=213`,
  fetchTrending: `/trending/all/week?api_key=${API_KEY}&language=en-US`,
  fetchTopRated: `/movie/top_rated?api_key=${API_KEY}&language=en-US`,
  fetchActionMovies: `/discover/movie?api_key=${API_KEY}&with_genres=28`,
  fetchComedyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=35`,
  fetchHorrorMovies: `/discover/movie?api_key=${API_KEY}&with_genres=27`,
  fetchRomanceMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10749`,
  fetchDocumentaries: `/discover/movie?api_key=${API_KEY}&with_genres=99`,
};
export default requests;
